const IconCheckCircled = ({
  width = "20",
  height = "20",
  fill = "#2CA95E",
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      className={className ? className : null}
      xmlns="http://www.w3.org/2000/svg"
      data-name="IconCheckCircled"
    >
      <path d="M7.72982 13.1042L13.8548 6.97917L12.4798 5.60417L7.72982 10.3542L5.41732 8.04167L4.06315 9.41667L7.72982 13.1042ZM9.02148 17.8542C7.7576 17.8542 6.58398 17.6285 5.50065 17.1771C4.41732 16.7257 3.47982 16.1042 2.68815 15.3125C1.89648 14.5208 1.27496 13.5833 0.823568 12.5C0.372179 11.4167 0.146484 10.2431 0.146484 8.97917C0.146484 7.74306 0.372179 6.58681 0.823568 5.51042C1.27496 4.43403 1.89648 3.49653 2.68815 2.69792C3.47982 1.89931 4.41732 1.27083 5.50065 0.8125C6.58398 0.354167 7.7576 0.125 9.02148 0.125C10.2576 0.125 11.4138 0.354167 12.4902 0.8125C13.5666 1.27083 14.5041 1.89931 15.3027 2.69792C16.1013 3.49653 16.7298 4.43403 17.1882 5.51042C17.6465 6.58681 17.8757 7.75 17.8757 9C17.8757 10.25 17.6465 11.4167 17.1882 12.5C16.7298 13.5833 16.1013 14.5208 15.3027 15.3125C14.5041 16.1042 13.5666 16.7257 12.4902 17.1771C11.4138 17.6285 10.2576 17.8542 9.02148 17.8542ZM9.00065 15.8958C10.959 15.8958 12.5979 15.2396 13.9173 13.9271C15.2368 12.6146 15.8965 10.9722 15.8965 9C15.8965 7.02778 15.2368 5.38542 13.9173 4.07292C12.5979 2.76042 10.959 2.10417 9.00065 2.10417C7.04232 2.10417 5.40343 2.76042 4.08398 4.07292C2.76454 5.38542 2.10482 7.02778 2.10482 9C2.10482 10.9722 2.76454 12.6146 4.08398 13.9271C5.40343 15.2396 7.04232 15.8958 9.00065 15.8958Z" fill={fill}/>

    </svg>

  );
};

export default IconCheckCircled;
